import * as tslib_1 from "tslib";
import { call, all, put, select } from 'redux-saga/effects';
import { withOffset, selectors } from '../../Stream';
import { getCurrentMediaSource, getCurrentFolderId, getFirstManageableGallectionIndex, } from '../selectors';
import { getGallectionStreamId, getGallectionDeviationStreamId, getGallectionTypeFromMediaSourceType, } from '../helpers';
import { normalize } from '../../redux/normalizr';
import { galleryFolderSchema, collectionFolderSchema, } from '../../redux/normalizr/schemas/folder';
import { MediaSourceType } from '../types';
import { MEDIA_POPUP_GALLECTION_DEVIATION_STREAM_GROUP, DEVIATIONS_PER_FETCH, } from '../constants';
import { request } from '../../xhr';
import { GallectionType } from '../../types/gallection';
import { getStreamInitAction } from './initGallectionStream';
export function fakeResponse(_a) {
    var data = _a.data;
    if (process.env.NODE_ENV !== 'production') {
        var galleries = require('@wix/da-sample-data').galleries; // eslint-disable-line global-require
        var response = {
            success: true,
            gallection: tslib_1.__assign({}, galleries[3], { folderId: -1000, name: data.name }),
        };
        return response;
    }
}
function createGallection(action) {
    var payload, mediaSource, currentFolderId, gallectionsStreamId, params, result, newGallection, gallectionSchema, entities, newGallectionOffset, _a, gallectionDeviationsStreamId, putActions, isGallectionStreamInitialized;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                payload = action.payload;
                if (!payload) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getCurrentMediaSource)];
            case 1:
                mediaSource = _b.sent();
                return [4 /*yield*/, select(getCurrentFolderId)];
            case 2:
                currentFolderId = _b.sent();
                gallectionsStreamId = getGallectionStreamId(mediaSource, currentFolderId);
                params = {
                    type: getGallectionTypeFromMediaSourceType(mediaSource) ===
                        GallectionType.GALLERY
                        ? 'gallery'
                        : 'collection',
                    name: payload.name,
                };
                if (currentFolderId) {
                    params['parent_folder_id'] = currentFolderId;
                }
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/create',
                        data: params,
                    }, fakeResponse)];
            case 3:
                result = _b.sent();
                if (!result || !result.success) {
                    return [2 /*return*/]; // TODO: error handling
                }
                newGallection = tslib_1.__assign({}, result.gallection, { parentId: currentFolderId });
                gallectionSchema = mediaSource === MediaSourceType.COLLECTION
                    ? collectionFolderSchema
                    : galleryFolderSchema;
                entities = normalize(newGallection, gallectionSchema).entities;
                if (!currentFolderId) return [3 /*break*/, 4];
                _a = 0;
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, select(getFirstManageableGallectionIndex)];
            case 5:
                _a = _b.sent();
                _b.label = 6;
            case 6:
                newGallectionOffset = _a;
                gallectionDeviationsStreamId = getGallectionDeviationStreamId(mediaSource, newGallection.folderId);
                putActions = [];
                if (!currentFolderId) return [3 /*break*/, 8];
                return [4 /*yield*/, select(function (state) {
                        return selectors.isInitialized(state, gallectionsStreamId);
                    })];
            case 7:
                isGallectionStreamInitialized = _b.sent();
                if (!isGallectionStreamInitialized) {
                    putActions.push(put(getStreamInitAction(mediaSource, currentFolderId)));
                }
                _b.label = 8;
            case 8:
                putActions.push(put(withOffset.actions.insertItems({
                    streamId: gallectionsStreamId,
                    items: [newGallection.folderId],
                    entities: entities,
                    offset: newGallectionOffset,
                })), put(withOffset.actions.initialize({
                    streamId: gallectionDeviationsStreamId,
                    groupId: MEDIA_POPUP_GALLECTION_DEVIATION_STREAM_GROUP,
                    streamParams: {
                        mediaSource: mediaSource,
                        folderId: newGallection.folderId,
                    },
                    items: [],
                    itemsPerFetch: DEVIATIONS_PER_FETCH,
                    hasMore: false,
                })));
                return [4 /*yield*/, all(putActions)];
            case 9:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export default createGallection;
//# sourceMappingURL=createGallection.js.map